import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencilSolidIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	x: "0px",
	y: "0px",
	viewBox: "0 0 20 20",
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		id: "style1",
		children: "\n	.pencil-icon-st0{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", {
		id: "g4",
		transform: "matrix(1.2506428,0,0,1.2400897,0.45704529,0.45310861)",
		children: /* @__PURE__ */ _jsx("g", {
			id: "g3",
			transform: "matrix(1.1141859,0,0,1.1140963,-0.04996408,-0.04992488)",
			style: { strokeWidth: .897552 },
			children: /* @__PURE__ */ _jsxs("g", {
				id: "g2",
				style: { strokeWidth: .897552 },
				children: [/* @__PURE__ */ _jsx("path", {
					className: "pencil-icon-st0",
					d: "M 4.4032414,13.441288 H 0.99091757 c -0.18444994,0 -0.27667491,-0.09223 -0.36889988,-0.18445 -0.092225,-0.09223 -0.18444993,-0.276675 -0.18444993,-0.368899 V 9.6600646 c 0,-0.092225 0,-0.1844499 0,-0.1844499 0,-0.092225 0.092225,-0.092225 0.092225,-0.18445 L 9.1989398,0.62201769 c 0.092225,-0.092225 0.2766749,-0.18444993 0.3688998,-0.18444993 0.092225,0 0.2766749,0.092225 0.3688999,0.18444993 L 13.164613,3.8498916 c 0.09223,0.092225 0.18445,0.2766749 0.18445,0.3688999 0,0.092225 -0.09222,0.2766749 -0.18445,0.3688998 z",
					id: "path1",
					style: {
						strokeWidth: 1.44144,
						strokeDasharray: "none"
					}
				}), /* @__PURE__ */ _jsx("path", {
					className: "pencil-icon-st0",
					d: "M 7.2622154,2.4665171 11.320114,6.5244157",
					id: "path2",
					style: {
						strokeWidth: 1.44144,
						strokeDasharray: "none"
					}
				})]
			})
		})
	})]
});
export default SvgPencilSolidIcon;
